export const MAIN_CLASS_NAME = 'elma365-tool-params-table';
export const TABLE_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__table-row`;
export const TABLE_ROW_DISABLED_CLASS_NAME = `${TABLE_ROW_CLASS_NAME}_disabled`;
export const CELL_SWITCH_CLASS_NAME = `${TABLE_ROW_CLASS_NAME}__cell-switch`;
export const CELL_DESCRIPTION_CLASS_NAME = `${TABLE_ROW_CLASS_NAME}__cell-description`;
